import axios, {download} from "../utils/axios";
import * as api from "./api";

export function videoList(params) {
    return new Promise((resolve, reject) => {
        axios.post(api.VIDEO_LIST, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch video list ', error)
                reject(error);
            })
    })
}

export function videoListForDetail(params) {
    return new Promise((resolve, reject) => {
        axios.post(api.VIDEO_LIST_FOR_DETAIL, params)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch video list ', error)
                reject(error);
            })
    })
}

export function hotVideoNameList() {
    return new Promise((resolve, reject) => {
        axios.post(api.VIDEO_HOT_NAME_LIST)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch video list ', error)
                reject(error);
            })
    })
}

export function videoDetail(id) {
    return new Promise((resolve, reject) => {
        axios.get(api.VIDEO_DETAIL + "/" + id)
            .then(response => {
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log('catch video detail ', error)
                reject(error);
            })
    })
}

export function videoDownload(url) {
    download(url);
}
